import { render, staticRenderFns } from "./blue.vue?vue&type=template&id=34d8682a&scoped=true&lang=pug&"
import script from "./blue.vue?vue&type=script&lang=js&"
export * from "./blue.vue?vue&type=script&lang=js&"
import style0 from "./blue.vue?vue&type=style&index=0&id=34d8682a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d8682a",
  null
  
)

export default component.exports